import { ChartRenderer, ChartTypePreview } from 'components/core';
import { CHART_TYPE, MOCK_CHART_DATA, MOCK_TABVIEW_DATA, normalizeChartType, RENDERABLE_CHART_TYPES } from 'constants/appConstants';

interface ChartPreviewProps {
  rawType: string;
  title: string;
  /** The Data tab's query text; a chart that reads it waits for it to be valid JSON. */
  queries: string;
}

/** The query as an object, or null while it is not valid JSON (or not an object). */
const queryObject = (text: string): object | null => {
  try {
    const parsed: unknown = JSON.parse(text);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
};

interface SampleChartProps {
  type: string;
  title: string;
}

/** The chart for this type, drawn from sample data. */
const SampleChart = ({ type, title }: SampleChartProps) => {
  if (type === CHART_TYPE.METRIC) return <ChartRenderer chartType={type} chartData={{ title, count: Math.floor(Math.random() * 100) }} />;
  if (type === CHART_TYPE.TABVIEW) return <ChartRenderer chartType={type} chartData={MOCK_TABVIEW_DATA} />;
  return <ChartRenderer chartType={type} chartData={MOCK_CHART_DATA} />;
};

/** The chart shown above the tabs. It uses sample data: it needs the query to be valid JSON but never runs it. Whether the query is valid is reported by useQueryValidity. */
export const ChartPreview = ({ rawType, title, queries }: ChartPreviewProps) => {
  if (!rawType) return null;
  const type = normalizeChartType(rawType);
  // Decorative fallback for types with no real chart component yet: it does not read the query.
  if (!RENDERABLE_CHART_TYPES.includes(type)) return <ChartTypePreview chartType={type} />;
  return queryObject(queries) ? <SampleChart type={type} title={title} /> : null;
};
